import {BaseService} from "./base.service";

class PaymentComplementService extends BaseService {

    constructor() {
        //super('api/invoices-for-supplier')
        super('api/invoice-list-and-upload')
    }

}

export const paymentComplementService = new PaymentComplementService();
